(function() {
  "use strict";
  angular.module("marketPlace.auction", []);
})();
